import type { LogoProps } from '#src/base/logo/logo.tsx';
import { LogoMark } from '#src/base/logo/logo_mark.tsx';
import { cn } from '#src/styling/cn.ts';

export type SpinnerProps = { className?: string } & Pick<LogoProps, 'size'>;

export const Spinner = ({ size, className }: SpinnerProps) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div className="animate-spin">
        <LogoMark size={size} />
      </div>
    </div>
  );
};
